import { render } from "./DefectsLists.vue?vue&type=template&id=e91e6b2e"
import script from "./DefectsLists.vue?vue&type=script&lang=js"
export * from "./DefectsLists.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__